import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import ActionButtonRenderer from '../action-button/action-button-renderer';
import AppStatusIndicator from '../app-status-indicator/app-status-indicator';
import { utilsService } from '../../core/services/utils.service';

@observer
export default class AppDetailInfoHeader extends React.Component {

	static propTypes = {
		app: PropTypes.object.isRequired,
		pageMode: PropTypes.string,
		isDirty: PropTypes.bool,
		validateAppUpdate: PropTypes.func.isRequired,
		pushChanges: PropTypes.func.isRequired,
		actionsCurrentlyLoading: PropTypes.object.isRequired,
		handleToggleModal: PropTypes.func.isRequired,
		handleCopyApp: PropTypes.func.isRequired,
		showActionButtons: PropTypes.bool
	}

	static defaultProps = {
		pageMode: ''
	}

	constructor(props) {
		super(props);
		this.srAppDescription = '';
		if (this.props.app.appName) {
			this.srAppDescription += `app ${this.props.app.appName}`
		}
		if (this.props.app.version) {
			this.srAppDescription += ` version ${this.props.app.version}`
		}
	}

	handleValidateApp = () => {
		if(this.props.isDirty) {
			this.props.validateAppUpdate();
		}
	};

	handleToggleModal = (modalName) => {
		this.props.handleToggleModal(modalName)
	};

	getSubHeader = (pageMode) => {
		switch (pageMode) {
			case 'view':
				return (<AppStatusIndicator status={this.props.app.status} inactiveStatus={this.props.app.statusReason} />);
			case 'review':
				return (<div className="app-edit-indicator">Review Changes</div>);
			case 'edit':
				return (<div className="app-edit-indicator">Edit mode</div>);
			default:
				return '';
		}
	}

	renderHeaderButtons = () => {
		const pageMode = this.props.pageMode;
		const status = (this.props.app.status && pageMode === 'view') ? this.props.app.status : '';
		const buttonsForPageMode = {
			view: [
				{
					label: 'Edit',
					className: 'as-link',
					icon: 'icon-edit ltblue',
					linkTo: utilsService.generateAppPageURI(this.props.app, 'edit'),
					srText: this.srAppDescription
				},
				{
					label: 'Copy',
					className: 'as-link with-left-border walkthrough-copy-app',
					icon: 'icon-copy ltblue',
					isLoading: this.props.actionsCurrentlyLoading.copy,
					loadingLabel: 'Copy',
					onClick: this.props.handleCopyApp,
					srText: this.srAppDescription
				},
				{
					label: 'Remove',
					className: 'as-link with-left-border walkthrough-remove-app',
					icon: 'icon-trash ltblue',
					onClick: () => this.handleToggleModal('removeApp'),
					srText: this.srAppDescription
				},
				{
					label: 'Withdraw',
					className: 'as-link with-left-border walkthrough-remove-app',
					onClick: () => this.handleToggleModal('withdrawApp'),
					icon: 'icon-withdraw ltblue',
					srText: this.srAppDescription
				}
			],
			review: [
				{
					label: 'Push Changes',
					className: 'as-link',
					icon: 'icon-save ltblue',
					onClick: () => this.props.pushChanges()
				},
				{
					label: 'Back To Edit',
					linkTo: utilsService.generateAppPageURI(this.props.app, 'edit'),
					className: 'btn-link with-left-border last',
					icon: 'icon-pencil ltblue'
				}
			],
			edit: [
				{
					label: 'Review Changes',
					linkTo: utilsService.generateAppPageURI(this.props.app, 'review'),
					className: `btn-link ${this.props.isDirty ? '' : 'disabled'}`,
					icon: `${this.props.isDirty ? 'ltblue' : 'mdgrey'} icon-clipboard-check`,
					onClick: this.props.validateAppUpdate,
					srOnly: `${this.props.isDirty ? '' : '. You have no changes to review.'}`
				},
				{
					label: 'Discard & Go Back',
					linkTo: utilsService.generateAppPageURI(this.props.app, 'view'),
					className: 'btn-link with-left-border last',
					icon: 'icon-trash-alt ltblue'
				}
			]
		};
		return (<ActionButtonRenderer status={status} className="app-info-action-links">
			{buttonsForPageMode[pageMode]}
		</ActionButtonRenderer>)
	};

	render() {
		return (
			<React.Fragment>
			<h2>Version {this.props.app.version}</h2>
			{this.getSubHeader(this.props.pageMode)}
			{this.props.showActionButtons && this.renderHeaderButtons()}
			</React.Fragment>
		)
	}
}
